var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"white--text",attrs:{"app":"","color":"accent2"}},[_c('span',[_vm._v("iSeries Readers")]),_c('v-spacer'),_c('span',[_vm._v(_vm._s(_vm.version))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }